<input type="checkbox" class="custom-control-input" id="{{ id }}" [formControl]="ctrl" />
<label class="custom-control-label form-label" for="{{ id }}">
  <ng-content></ng-content>
  {{ label }}
</label>
